import { Link } from "react-router-dom";
import { useEffect } from "react";
import Seo from "../components/Seo";
import { Button } from "../components/ui/button";

export default function NotFound() {
  useEffect(() => {
    // SPA: non possiamo restituire lo status 404 reale lato client; segnaliamo noindex.
    // Un eventuale layer SSR/edge può leggere questo flag per rispondere 404.
    if (typeof window !== "undefined") window.__NOT_FOUND__ = true;
  }, []);
  return (
    <div className="max-w-xl mx-auto px-4 py-24 text-center" data-testid="notfound-page">
      <Seo
        title="Pagina non trovata (404) | Libri in Circolo"
        description="La pagina che cerchi non esiste o è stata spostata."
        noindex
      />
      <p className="text-6xl font-serif font-bold text-primary">404</p>
      <h1 className="text-2xl font-serif font-semibold mt-4">Pagina non trovata</h1>
      <p className="text-muted-foreground mt-2">La pagina che cerchi non esiste o è stata spostata.</p>
      <Button asChild className="mt-6 bg-primary hover:bg-primary/90"><Link to="/" data-testid="notfound-home">Torna al catalogo</Link></Button>
    </div>
  );
}
